import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-resource-name-cell-renderer',
  template: `
    <div class="resource-container">
      <a
        href="javascript:void(0)"
        class="resource-link"
        (click)="onResourceClick($event)"
        [title]="getTooltip()"
      >
        <div class="resource-name">{{ getDisplayName() }}</div>
        <div class="resource-details">
          {{ getEmployeeId() }} | {{ getDesignation() }}
        </div>
      </a>
    </div>
  `,
  styles: [
    `
      .resource-container {
        display: flex;
        align-items: center;
        height: 100%;
        padding: 4px 0;
      }

      .resource-link {
        text-decoration: none;
        cursor: pointer;
        display: block;
        line-height: 1.2;
      }

      .resource-name {
        font-weight: 400;
        font-size: 14px;
        margin-bottom: 2px;
        color: #003f2d;
        text-decoration: underline;
        transition: color 0.2s ease;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 180px;
        max-width: 200px;
      }

      .resource-details {
        font-size: 12px;
        color: #6c757d;
        font-weight: 400;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 180px;
        max-width: 200px;
      }
    `,
  ],
})
export class ResourceNameCellRendererComponent
  implements ICellRendererAngularComp
{
  params!: ICellRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }

  getDisplayName(): string {
    // Try to get from individual fields first, fallback to resourceName field
    return this.params.data.firstName && this.params.data.lastName
      ? `${this.params.data.firstName} ${this.params.data.lastName}`
      : this.params.data.fullName ||
          this.params.data.resourceName?.split('\n')[0] ||
          '';
  }

  getEmployeeId(): string {
    return this.params.data.employeeId || '';
  }

  getDesignation(): string {
    return (
      this.params.data.designation ||
      this.params.data.role ||
      this.params.data.jobTitle ||
      ''
    );
  }

  getTooltip(): string {
    return `Click to view details for ${this.getDisplayName()} (${this.getEmployeeId()})`;
  }

  onResourceClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();


    if (this.params?.context?.onResourceClick) {
      this.params.context.onResourceClick({
        employeeId: this.getEmployeeId(),
        resourceName: this.getDisplayName(),
        designation: this.getDesignation(),
        firstName: this.params.data.firstName,
        lastName: this.params.data.lastName,
        rowData: this.params.data,
      });
    } else {
      console.error(
        'ResourceNameCellRenderer: onResourceClick not found in context!',
        {
          hasParams: !!this.params,
          hasContext: !!this.params?.context,
          hasOnResourceClick: !!this.params?.context?.onResourceClick,
          context: this.params?.context,
        },
      );
    }
  }
}
